import React from 'react';
import { PageCover } from '../Cover';
import { eBrandImageSizes, LoadingImage } from '../BrandImages';

interface ILoadingProps {
  isLoading: boolean;
  children?: React.ReactNode;
}

// Page loading will fill the full page and is intended to be used before a page loads
// Can be used at other times since it does in effect provide a cover to content that could be "behind" it
// Could be extended to include children under the loading icon, but I'm not dealing with the styling right now since it's not needed right now.
export const PageLoading: React.FC<ILoadingProps> = (props) => {
  return props.isLoading ? (
    <PageCover>
      <LoadingImage imageSize={eBrandImageSizes.Normal} />
    </PageCover>
  ) : (
    <>{props.children}</>
  );
};
